import Splide from '@splidejs/splide';
import modal, { type ModalComponent } from '../modal';

type SlideshowModalComponent = ModalComponent & {
    modalSplide: Splide | null;
    splideTimeout: number | null;
    mountCarousel(index: number): void;
    clearSplideTimeout(): void;
    destroySplide(): void;
    scheduleSplideDestroy(): void;
};

export default function slideshowModal(): SlideshowModalComponent {
    return {
        ...modal(),
        modalSplide: null,
        splideTimeout: null,

        init() {
            this.$watch('isOpen', (value: boolean) => {
                document.body.style.overflow = value ? 'hidden' : '';

                if (value) {
                    this.clearSplideTimeout();
                } else {
                    this.scheduleSplideDestroy();
                }
            });
        },

        destroy() {
            document.body.style.overflow = '';
            this.destroySplide();
        },

        openModal(index = 0) {
            this.clearSplideTimeout();
            this.previouslyFocused =
                document.activeElement instanceof HTMLElement ? document.activeElement : null;
            this.isOpen = true;

            this.$nextTick(() => {
                this.$refs.closeButton?.focus();
                this.mountCarousel(index);
            });
        },

        mountCarousel(index: number) {
            if (this.modalSplide) {
                this.modalSplide.destroy(true);
            }

            requestAnimationFrame(() => {
                if (!this.isOpen || !this.$refs.modalCarousel) {
                    return;
                }

                this.modalSplide = new Splide(this.$refs.modalCarousel, {
                    type: 'slide',
                    rewind: true,
                    perPage: 1,
                    gap: 0,
                    drag: true,
                    arrows: true,
                    pagination: true,
                    start: Number(index) || 0,
                    keyboard: 'global',
                }).mount();
            });
        },

        clearSplideTimeout() {
            if (!this.splideTimeout) {
                return;
            }

            window.clearTimeout(this.splideTimeout);
            this.splideTimeout = null;
        },

        destroySplide() {
            this.clearSplideTimeout();

            if (!this.modalSplide) {
                return;
            }

            this.modalSplide.destroy(true);
            this.modalSplide = null;
        },

        scheduleSplideDestroy() {
            if (!this.modalSplide || this.splideTimeout) {
                return;
            }

            const modalSplide = this.modalSplide;

            this.splideTimeout = window.setTimeout(() => {
                if (!this.isOpen && this.modalSplide === modalSplide) {
                    this.destroySplide();
                }

                this.splideTimeout = null;
            }, 250);
        },
    };
}
